import { MdEdit } from 'react-icons/md';
import Tooltip from '../Tooltip/Tooltip';
import './BotaoEditar.css';

const BotaoEditar = ({ onClick, info, tooltip = "Editar", className = 'botao-acao-editar', icone = <MdEdit />}) => (
  <Tooltip text={tooltip}>
    <button
      className={className}
      onClick={e => {
        e.stopPropagation();
        onClick(info);
      }}
      type="button"
    >
      {icone}
    </button>
  </Tooltip>
);

export default BotaoEditar;
